module.exports = __webpack_public_path__ + "b4635a50348b09ac10503abd01cc9a55.png";